import { render, staticRenderFns } from "./DepositsReceived.vue?vue&type=template&id=640905ae&"
import script from "./DepositsReceived.vue?vue&type=script&lang=js&"
export * from "./DepositsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports